module.exports = __webpack_public_path__ + "media/images/let-you-screen/bg-img-ff69af41cb97d56b451f1dab945298c2.svg";